import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcCommonModule } from '../../common/common.module';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { ErrorHandlerModule } from '../../common/error-handler/error-handler.module';
import { HelpModalModule } from '../../help-modal/help-modal.module';
import { NgcStoreModule } from '../../store/store.module';
import { MytripsLoggedInModule } from './mytrips-logged-in/mytrips-logged-in.module';
// This Module's Components
import { NavigationMytripsComponent } from './navigation-mytrips.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    DataLayerModule,
    NgcCommonModule,
    HelpModalModule,
    ModalModule.forRoot(),
    HttpClientModule,
    ErrorHandlerModule,
    FormsModule,
    NgcStoreModule,
    MytripsLoggedInModule
  ],
  declarations: [NavigationMytripsComponent],
  exports: [NavigationMytripsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationMytripsModule {}
